import { H3 } from 'foundations-components/transitional/components/H3';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Section } from 'foundations-components/transitional/components/Section';
import ExamFinishedSecondaryButtons from './ExamFinishedSecondaryButtons';
import PracticalExercisesOutstanding from './PracticalExercisesOutstanding';
import ExamLoadingScreen from './ExamLoadingScreen';
import ExamErrorScreen from './ExamErrorScreen';
import { View } from 'foundations-components/components/View';
import FinishedContainer from '../../../components/FinishedContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExamFinishedScreenLayout = ({
  illustration,
  heading,
  subheading,
  prompt,
  callToAction,
  trackId,
  loading,
  error,
  showSecondaryRetakeCTA,
  language
}) => {
  if (loading) return /*#__PURE__*/_jsx(ExamLoadingScreen, {});
  if (error) return /*#__PURE__*/_jsx(ExamErrorScreen, {
    error: error
  });
  const body = /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(H3, {
      "data-test-id": "exam-finished-screen-heading",
      children: heading
    }), /*#__PURE__*/_jsx(Section, {
      "data-test-id": "exam-finished-screen-subheading",
      children: subheading
    }), prompt && /*#__PURE__*/_jsx(Section, {
      children: prompt
    }), callToAction && /*#__PURE__*/_jsx(Section, {
      "data-test-id": "exam-finished-screen-primary-ctas",
      children: callToAction
    }), /*#__PURE__*/_jsx(PracticalExercisesOutstanding, {
      language: language,
      trackId: trackId
    })]
  });
  return /*#__PURE__*/_jsx(FinishedContainer, {
    body: body,
    footer: /*#__PURE__*/_jsx(ExamFinishedSecondaryButtons, {
      language: language,
      retake: showSecondaryRetakeCTA,
      trackId: trackId
    }),
    illustration: /*#__PURE__*/_jsx(Illustration, {
      name: illustration
    })
  });
};
export default ExamFinishedScreenLayout;